import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { getDateFromDate, getTimeFromDate } from "../../classes/utils/dateTime.tsx";
import { getDateFromTimestamp } from "../../classes/utils/timestamp.tsx";
import { useTranslation } from "react-i18next";
import theme from "../../style/theme.jsx";

export default function MailsTable({mails, onClick}) {
    const { t } = useTranslation();
    return <TableContainer component={Paper}>
        <Table aria-label="mails-table">
            <TableHead>
                <TableRow sx={{backgroundColor: theme.palette.primary.main}}>
                    <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('mails.table.mail')}</TableCell>
                    <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('mails.table.date')}</TableCell>
                    <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('mails.table.time')}</TableCell>
                    <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('mails.table.id')}</TableCell>
                    <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('mails.table.state')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {mails.map((mail, index) => <TableRow key={index} onClick={() => {onClick(mail)}} className="clickable hover-color">
                    <TableCell>{mail.getTo().length === 0 ? '' : mail.getTo().length === 1 ? mail.getTo()[0] : 'Multiple recipients'}</TableCell>
                    <TableCell>{getDateFromDate(getDateFromTimestamp(mail.getDelivery().getStartTime()))}</TableCell>
                    <TableCell>{getTimeFromDate(getDateFromTimestamp(mail.getDelivery().getStartTime()))}</TableCell>
                    <TableCell>{mail.getId()}</TableCell>
                    <TableCell>{mail.getDelivery().getState()}</TableCell>
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer>;
}